export function resolveCmsAsset(path, fallback = "") {
  const value = path || fallback;

  if (!value) return "";
  if (/^(https?:|data:|blob:)/.test(value)) return value;
  if (value.startsWith("/image/") || value.startsWith("/file/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${value}`;
  }

  return `${process.env.PUBLIC_URL}${value}`;
}
